/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Modal } from "react-bootstrap";
import { CSVLink, CSVDownload } from "react-csv";
import html2canvas from "html2canvas";
import refreshBtn from "../../assets/images/refresh_btn.png";
// import Modal from "react-bootstrap/Modal";
import CloseIcon from "@mui/icons-material/Close";
import {
  exportComponentAsJPEG,
  exportComponentAsPDF,
  exportComponentAsPNG,
} from "react-component-export-image";
import {
  TextField,
  Box,
  //   Grid as MuiGrid,
  Button,
  IconButton,
  Typography,
  Grid,
  useMediaQuery,
} from "@mui/material";
import Swal from "sweetalert2";
import SoftSnackbar from "components/SoftSnackbar";
import styled from "@emotion/styled";
import imga1 from "../../assets/images/imga1.png";
import imga2 from "../../assets/images/imga2.png";
import imga3 from "../../assets/images/imga3.png";
import imga4 from "../../assets/images/imga4.png";
import imga5 from "../../assets/images/imga5.png";
import imga6 from "../../assets/images/peoples.png";
import refresh from "../../assets/images/refresh.png";
import AddIcon from "@mui/icons-material/Add";
import noDataImg from "../../../src/assets/images/browser.png";
import { Table } from "ant-table-extensions";
import { useState } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import moment from "moment";
import scanQR from "../../assets/images/scan_qr.jpg";
import { set } from "immutable";
import "./style.css";

export default function Assistant() {
  // var fileSaver = require("file-saver");
  const matchsm = useMediaQuery("(max-width:768.5px)");
  console.log("Cp_type", sessionStorage.getItem("cp_type"));
  const [generateModal, setGenerateModal] = useState(false);
  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [showqr, setShowqr] = useState(false);
  const [showName, setShowName] = useState("");
  const [showLName, setshowLName] = useState("");
  const [Qrlink, setQrlink] = useState({});
  const [test1, setTest] = useState({});
  const [payloadObj, setPayloadObj] = useState({
    name: "",
    mobile: "",
    state: "",
    district: "",
    taluka: "",
  });

  const ST1 = styled(Typography)({
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "26px",
    fontFamily: "Poppins",
    color: "#6C6C6C",
  });

  const ST2 = styled(Typography)({
    fontSize: "24px",
    fontWeight: 500,
    lineHeight: "26px",
    fontFamily: "Poppins",
    color: "#FF8000",
  });

  const ST3 = styled(Typography)({
    fontSize: "24px",
    fontWeight: 500,
    lineHeight: "26px",
    fontFamily: "Poppins",
    color: "#3B5092",
  });

  const ST4 = styled(Typography)({
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "26px",
    fontFamily: "Poppins",
    color: "#000000",
  });

  const stylesDD = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      // borderColor: state.isFocused ? "grey" : "red",
      fontSize: "14px",
      fontFamily: "Poppins",
    }),
    option: (base) => ({
      ...base,
      // border: `1px dotted red`,
      height: "100%",
      fontSize: "14px",
      fontFamily: "Poppins",
    }),
  };

  const colName = [
    {
      title: "Name",
      dataIndex: "name",
      width: !matchsm ? 200 : 100,
      fixed: !matchsm ? "left" : "none",
      sorter: {
        compare: (a, b) => a?.name?.localeCompare(b?.name),
        multiple: 1,
      },
    },
    {
      title: "Phone",
      dataIndex: "mobnum",
      width: 150,
      sorter: {
        compare: (a, b) => a.mobnum - b.mobnum,
        multiple: 2,
      },
    },
    {
      title: "State",
      //dataIndex: "state",
      width: 150,
      sorter: {
        compare: (a, b) => a?.state?.localeCompare(b?.state),
        multiple: 6,
      },
      render: (text) => <>{text.state === "" ? "-" : text.state}</>,
    },
    {
      title: "District",
      //dataIndex: "district",
      width: 150,
      sorter: {
        compare: (a, b) => a?.district?.localeCompare(b?.district),
        multiple: 7,
      },
      render: (text) => <>{text.district === "" ? "-" : text.district}</>,
    },
    {
      title: "Taluka",
      //dataIndex: "district",
      width: 150,
      sorter: {
        compare: (a, b) => a?.taluka?.localeCompare(b?.taluka),
        multiple: 7,
      },
      render: (text) => <>{text.taluka === "" ? "-" : text.taluka}</>,
    },
    {
      title: "Candidates Shared",
      // dataIndex: "candidate_count",
      width: 100,
      sorter: {
        compare: (a, b) => a.candidate_count - b.candidate_count,
        multiple: 2,
      },
      render: (text) => (
        <>
          <div style={{ display: "flex", justifyContent: "center" }}>{text.candidate_count}</div>
        </>
      ),
    },
    {
      title: "QR Link",
      // dataIndex: "qr",
      width: 100,
      //   sorter: {
      //     compare: (a, b) => a?.district?.localeCompare(b?.district),
      //     multiple: 7,
      //   },
      //   render: (text) => <>{text.district === "" ? "-" : text.district}</>,
      render: (text) => (
        <>
          <div style={{ display: "flex", justifyContent: "center", gap: "25px" }}>
            <a href={text.form_link} target="_blank" rel="noreferrer">
              <div
                style={{
                  cursor: "pointer",
                  width: "35px",
                  height: "31px",
                  border: "0.5px solid #C6C6C6",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              // onClick={() => DeclineJPFunc(text)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g id="link">
                    <path
                      id="Icon"
                      d="M14 7H16C18.7614 7 21 9.23858 21 12C21 14.7614 18.7614 17 16 17H14M10 7H8C5.23858 7 3 9.23858 3 12C3 14.7614 5.23858 17 8 17H10M8 12H16"
                      stroke="#606060"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </div>
            </a>
            {/* <a download href={`${text.qr_code}`} target="_blank" rel="noreferrer"> */}
            <div
              style={{
                cursor: "pointer",
                width: "35px",
                height: "31px",
                border: "0.5px solid #C6C6C6",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // margin: "auto",
              }}
              onClick={() => {
                // var blob = new Blob([text.qr_code], { type: ".png" });
                // fileSaver.saveAs(blob, "qrcode.png");
                urlToObject(text.qr_code);
                setShowName(text.name);
              }}
            >
              <div
                style={{
                  cursor: "pointer",
                  width: "35px",
                  height: "31px",
                  border: "0.5px solid #C6C6C6",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  // margin: "auto",
                }}
              // onClick={() => AcceptJPFunc(text)}
              >
                <img src={scanQR} alt="" />
              </div>
            </div>
            {/* </a> */}
          </div>
        </>
      ),
    },
  ];

  const fetchStateList = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/generic/state`)
      .then((res) => {
        setStateList(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const fetchCity = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/generic/district`, {
        params: { state: selectedState },
      })
      .then((res) => {
        setDistrictList(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleRegistration = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      mobile: "",
      state: "",
      district: "",
      taluka: "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Please enter name"),
      mobile: Yup.string()
        .required(" Please enter mobile number")
        .matches(/^[0-9]+$/, "Must be only digits")
        .length(10, "Please enter 10 digit number"),
      state: Yup.string().required("Please enter state"),
      district: Yup.string().required("Please enter district"),
      // taluka: Yup.string().required("Please enter taluka"),
    }),
    onSubmit: (values, { resetForm }) => {
      setIsLoading(true);
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_GENERIC_URL}/superadmin/register/channelpartner/digitalvolunteer/register`,
          {
            name: values.name,
            mobile: values.mobile,
            state: values.state,
            district: values.district,
            taluka: values.taluka,
            createdby: sessionStorage.getItem("register_id"),
            type:
              sessionStorage.getItem("cp_type") === "SRS"
                ? sessionStorage.getItem("cp_type")
                : "Job Center",
            // sessionStorage.getItem("cp_type") !== "null" ||
            // sessionStorage.getItem("cp_type") !== null
            //   ? sessionStorage.getItem("cp_type")
            //   : "Job Center",
          }
        )
        .then((res) => {
          console.log("assist cp reg:", res);
          setGenerateModal(false);
          urlToObject(res.data.qr_link);
          setQrlink(res.data);
          setShowName(values.name);

          // DownloadFunc(res.data);
          // Swal.fire({
          //   //position: "top",
          //   icon: "success",
          //   title: "Registration Successful",
          //   //text: "Channel Partner Registered Successfully",
          //   showConfirmButton: false,
          //   timer: 3000,
          // }).then(() => {
          //   handleRegistration.resetForm();
          //   setIsLoading(false);
          // });
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: err.response.data["Developer Message"]
              ? err.response.data["Developer Message"]
              : "Something went wrong!",
            text: err.response.data["User Message"]
              ? err.response.data["User Message"]
              : "Something went wrong!",
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            // navigate("/superadmin/dashboard");
            setIsLoading(false);
          });
        });
    },
  });

  const urlToObject = async (value) => {
    const response = await fetch(value);
    // here image is url/location of image
    const blob = await response.blob();
    const file = new File([blob], "image.jpg", { type: blob.type });
    console.log(file);

    setTest(URL.createObjectURL(file));
    setShowqr(true);
  };

  const fetchAllVolunteers = () => {
    setIsLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/superadmin/register/channelpartner/digitalvolunteer/register`,
        { params: { cpid: sessionStorage.getItem("register_id") } }
      )
      .then((res) => {
        console.log("data cp:", res.data["Developer Message"]);
        setSearchData(
          res.data["Developer Message"]?.map((item, id) => ({
            registration_id: item.registration_id,
            name: item.name,
            mobnum: item?.mobnum?.length === 12 ? item.mobnum.substring(2) : item.mobnum,
            // mobnum: item.mobnum,
            candidate_count: item.candidate_count ? item.candidate_count : "0",
            state: item.state,
            district: item.district,
            taluka: item.district,
            form_link: item.form_link,
            qr_code: item.qr_code,
            createddt: moment(item.createddt).format("DD-MM-YYYY"),
            createdby: item.createdby,
          }))
        );
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const DownloadFunc = (data) => {
    console.log("in download func", data);
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-success",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Phygital Volunteer Registered Successfully",
        // text: `Your work order (id: ${data.work_order_id}) for ${data.job_data.applicantct} candidates of ${data.job_data.designation} for ${data.job_data.org_name} has been generated.`,
        icon: "success",
        // showCancelButton: true,
        // confirmButtonColor: "#3B5092",
        // cancelButtonColor: "#3B5092",
        // confirmButtonText: "Download",
        // cancelButtonText: "Proceed",
        showCancelButton: false,
        confirmButtonText: "Download QR",
      })
      .then((result) => {
        // if (result.isConfirmed) {
        //   Swal.fire("Downloaded!", "Your work order has been downloaded.", "success").then(() =>
        //     RequestedList()
        //   );
        // } else {
        //   setStep2(true);
        //   setStep1(false);
        //   // RequestedList();
        //   AcceptedList();
        // }
        if (result.isConfirmed) {
          // RequestedList();
          // var blob = new Blob([data.qr_link], { type: ".png" });
          // fileSaver.saveAs(blob, "qrcode.png");
          console.log(data);
          // exportComponentAsPNG(this.componentRef)
          // const blob = data.qr_link.blob();
          // const url = window.URL.createObjectURL(blob);
          // const url = data.qr_link;
          // const a = document.createElement("a");
          // a.href = url;
          // a.download = "qrcode.png";
          // document.body.appendChild(a);
          // a.click();
          // window.URL.revokeObjectURL(url);
          // handleRegistration.resetForm();
          // setIsLoading(false);
          // fetchAllVolunteers();
        }
      });
  };

  useEffect(() => {
    fetchStateList();
    fetchAllVolunteers();
  }, []);

  useEffect(() => {
    fetchCity();
  }, [selectedState]);

  return (
    <>
      <DashboardLayout>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: "wrap",
          }}
        >
          <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>
            {/* <img
              src={imga6}
              height={"30px"}
              style={{ marginTop: "8px", marginBottom: "8px" }}
              alt=""
            /> */}
            <Box
              sx={
                !matchsm
                  ? {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0px 8px",
                    gap: "10px",
                  }
                  : { display: "flex", flexDirection: "row" }
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="30"
                viewBox="0 0 34 30"
                fill="none"
              >
                <path
                  d="M22.8873 6.28852H10.223V12.089C10.223 13.8548 10.9459 15.4611 12.1105 16.6246C13.2741 17.7882 14.8804 18.5111 16.6462 18.5111C18.4001 18.5111 19.9957 17.799 21.1689 16.6376C21.463 16.3424 21.7184 16.0353 21.9446 15.7057H19.5109C19.387 16.058 19.1435 16.3682 18.8149 16.6096C18.3764 16.9328 17.7796 17.1332 17.1288 17.1332C16.4781 17.1332 15.8802 16.9328 15.4428 16.6096C14.9558 16.2508 14.6552 15.7412 14.6552 15.167C14.6552 14.5928 14.9569 14.0832 15.4428 13.7244C15.8813 13.4012 16.4781 13.2008 17.1288 13.2008C17.7796 13.2008 18.3775 13.4012 18.8149 13.7244C19.1424 13.9657 19.3859 14.276 19.5109 14.6283H22.5415C22.8808 13.8483 23.0683 12.9897 23.0683 12.089V6.28528L22.8884 6.28852H22.8873ZM9.14566 5.73476C9.14997 4.16182 9.7953 2.73109 10.8349 1.69037C11.8789 0.646412 13.3161 0 14.8955 0H28.0985C28.3958 0 28.6371 0.241327 28.6371 0.538677C28.6371 2.117 27.9907 3.55419 26.9479 4.59815C26.1894 5.3566 25.2219 5.90498 24.1446 6.14846V10.9125H24.6391C25.2963 10.9125 25.8953 11.1819 26.3294 11.616C26.7647 12.0524 27.0351 12.6514 27.0351 13.3086C27.0351 13.9679 26.7658 14.568 26.3316 15.0011C25.8974 15.4352 25.2984 15.7046 24.6402 15.7046H23.2094C22.8658 16.323 22.4391 16.8886 21.9425 17.3842L21.9101 17.4133C20.5527 18.7557 18.6899 19.5863 16.6451 19.5863C14.582 19.5863 12.7063 18.7427 11.3478 17.3842C9.98923 16.0256 9.14566 14.15 9.14566 12.0868V5.7326V5.73476ZM18.1793 14.5906C17.9175 14.3978 17.5458 14.2771 17.1278 14.2771C16.7098 14.2771 16.3381 14.3967 16.0763 14.5906C15.863 14.7479 15.7304 14.9526 15.7304 15.167C15.7304 15.3803 15.863 15.5861 16.0763 15.7434C16.3381 15.9362 16.7098 16.0569 17.1278 16.0569C17.5458 16.0569 17.9175 15.9373 18.1793 15.7434C18.3894 15.5882 18.5208 15.3878 18.5251 15.1627C18.5208 14.9472 18.3894 14.7468 18.1793 14.5917V14.5906ZM23.6996 14.6283H24.6402C25.0011 14.6283 25.3307 14.4796 25.5699 14.2405C25.8091 14.0013 25.9578 13.6716 25.9578 13.3096C25.9578 12.9466 25.8091 12.6158 25.571 12.3777C25.3329 12.1396 25.0022 11.9909 24.6391 11.9909H24.1446V12.089C24.1446 12.9789 23.9873 13.8343 23.6996 14.6283ZM13.4324 20.5818H24.4118C26.8541 20.5818 29.0745 21.5816 30.683 23.189C32.2926 24.7985 33.2913 27.019 33.2913 29.4613C33.2913 29.7587 33.05 30 32.7526 30H0.538677C0.241327 30 0 29.7587 0 29.4613C0 27.02 0.998707 24.8007 2.6072 23.1911C4.21892 21.5805 6.43827 20.5818 8.87955 20.5818H13.4324Z"
                  fill="#3B5092"
                />
              </svg>

              <Box sx={{ m: 0.5 }}>
                <ST3 variant="body1">Create Phygital Volunteer</ST3>
              </Box>
            </Box>
            <Button
              onClick={() => setGenerateModal(true)}
              sx={{
                m: 0.5,
                p: 2,
                width: !matchsm ? "80px" : "100%",
                height: "34px",
                background: "#3B5092",
                textTransform: "none",
                "&:hover": {
                  background: "#3B5092",
                },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "26px",
                  fontFamily: "Poppins",
                  color: "#FFFFFF",
                  margin: "0px 4px",
                }}
              >
                <AddIcon fontSize="large" />
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "26px",
                  fontFamily: "Poppins",
                  color: "#FFFFFF",
                  marginRight: "8px",
                }}
              >
                {/* Add */}
                create
              </Typography>

              {/* <img src={refresh} height={"24px"} alt="" /> */}
            </Button>
          </Box>

          <SoftBox
            sx={{
              height: "34px",
              backgroundColor: "#FFF",
              borderRadius: "2px",
              cursor: "pointer",
              p: 1
            }}
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="40px"
            onClick={() => (fetchAllVolunteers(), fetchStateList())}
          >
            <SoftBox>
              <img src={refreshBtn} />
            </SoftBox>
          </SoftBox>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: "wrap",
          }}
        >
          <Box sx={{ m: 1, mb: 0, minWidth: !matchsm ? "300px" : "100%" }}>
            <SoftInput
              isClearable
              id="search-bar"
              className="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              variant="outlined"
              placeholder="Search by name and contact number"
            />
          </Box>
        </Box>
        <Grid container>
          <Grid item xs={12} lg={12}>
            <Table
              loading={isLoading}
              columns={colName}
              dataSource={searchData?.filter((ele) => {
                return name?.toLocaleLowerCase() === ""
                  ? ele
                  : ele.name?.toLocaleLowerCase().includes(name.toLocaleLowerCase()) ||
                    name.toLocaleLowerCase() === ""
                    ? ele
                    : String(ele.mobnum).toLocaleLowerCase().includes(name.toLocaleLowerCase());
              })}
              // dataSource={searchData}
              scroll={{ x: 1800, y: 330 }}
              pagination={{
                pageSizeOptions: ["10", "20", "50", "100", "500"],
                // total: paginationState.dataSize,
                showSizeChanger: true,
                showTotal: (total, range) => (
                  <span>
                    Showing{" "}
                    <strong>
                      {range[0]} - {range[1]}
                    </strong>{" "}
                    results of {total}
                  </span>
                ),
              }}
            />
          </Grid>
        </Grid>
      </DashboardLayout>

      {/* Modal for assistant register */}
      <Modal
        show={generateModal}
        onHide={() => {
          setGenerateModal(false);
          // setShowSnackbar(false);
          handleRegistration.resetForm();
        }}
        centered
      >
        <Modal.Body>
          <SoftBox sx={{ m: 0 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: -1.5,
              }}
            >
              <p className="HeaderCSV"></p>
              <p
                // className="HeaderCSV"
                style={{ fontSize: "16px", fontWeight: 600, color: "#000" }}
              >
                {/* Digital Volunteer Registration */}
                Create Phygital Volunteer
              </p>
              <IconButton onClick={() => setGenerateModal(false)}>
                {/* <CloseIcon fontSize="small" /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </Box>
            <SoftBox>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={6}>
                  <SoftBox display="flex" flexDirection="row">
                    <SoftTypography fontWeight="medium" fontSize="15px">
                      Name
                    </SoftTypography>
                    <SoftBox
                      sx={{
                        color: "red",
                        position: "inherit",
                        paddingLeft: "2px",
                        fontSize: "15px",
                      }}
                    >
                      <sup>*</sup>
                    </SoftBox>
                  </SoftBox>
                  <SoftInput
                    type="text"
                    placeholder="Enter name"
                    id="name"
                    name="name"
                    // value={payloadObj?.name}
                    // onChange={(e) => setPayloadObj({ ...payloadObj, name: e.target.value })}
                    value={handleRegistration.values.name}
                    onChange={handleRegistration.handleChange}
                  />
                  {handleRegistration.touched.name && handleRegistration.errors.name ? (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {handleRegistration.errors.name}
                    </span>
                  ) : null}
                </Grid>
                <Grid item xs={12} lg={6}>
                  <SoftBox display="flex" flexDirection="row">
                    <SoftTypography fontWeight="medium" fontSize="15px">
                      Phone
                    </SoftTypography>
                    <SoftBox
                      sx={{
                        color: "red",
                        position: "inherit",
                        paddingLeft: "2px",
                        fontSize: "15px",
                      }}
                    >
                      <sup>*</sup>
                    </SoftBox>
                  </SoftBox>
                  <SoftInput
                    type="tel"
                    inputProps={{ maxLength: 10 }}
                    // maxLength={10}
                    // sx={{
                    //   inputProps: {
                    //     maxLength: "10",
                    //   },
                    // }}
                    placeholder="Enter mobile number"
                    id="mobile"
                    name="mobile"
                    // value={payloadObj?.mobile}
                    // onChange={(e) => setPayloadObj({ ...payloadObj, mobile: e.target.value })}
                    value={handleRegistration.values.mobile}
                    onChange={handleRegistration.handleChange}
                  />
                  {handleRegistration.touched.mobile && handleRegistration.errors.mobile ? (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {handleRegistration.errors.mobile}
                    </span>
                  ) : null}
                </Grid>
                <Grid item xs={12} lg={6}>
                  <SoftBox display="flex" flexDirection="row">
                    <SoftTypography fontWeight="medium" fontSize="15px">
                      State
                    </SoftTypography>
                    <SoftBox
                      sx={{
                        color: "red",
                        position: "inherit",
                        paddingLeft: "2px",
                        fontSize: "15px",
                      }}
                    >
                      <sup>*</sup>
                    </SoftBox>
                  </SoftBox>
                  <Select
                    styles={stylesDD}
                    // isClearable
                    placeholder="Select state"
                    options={stateList}
                    // value={{
                    //   label: payloadObj?.state,
                    //   value: payloadObj?.state,
                    // }}
                    // onChange={(e) => setPayloadObj({ ...payloadObj, state: e ? e.value : "" })}
                    value={{ label: handleRegistration.values.state }}
                    onChange={(e) => (
                      //   setPayloadObj({ ...payloadObj, state: e ? e.value : "" }),
                      setSelectedState(e.value), handleRegistration.setFieldValue("state", e.label)
                    )}
                  />
                  {handleRegistration.touched.state && handleRegistration.errors.state ? (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {handleRegistration.errors.state}
                    </span>
                  ) : null}
                </Grid>
                <Grid item xs={12} lg={6}>
                  <SoftBox display="flex" flexDirection="row">
                    <SoftTypography fontWeight="medium" fontSize="15px">
                      District
                    </SoftTypography>
                    <SoftBox
                      sx={{
                        color: "red",
                        position: "inherit",
                        paddingLeft: "2px",
                        fontSize: "15px",
                      }}
                    >
                      <sup>*</sup>
                    </SoftBox>
                  </SoftBox>
                  <Select
                    styles={stylesDD}
                    // isClearable
                    placeholder="Select district"
                    options={districtList}
                    // value={{
                    //   label: payloadObj?.district,
                    //   value: payloadObj?.district,
                    // }}
                    // onChange={(e) => setPayloadObj({ ...payloadObj, district: e ? e.value : "" })}
                    value={{ label: handleRegistration.values.district }}
                    onChange={(e) => handleRegistration.setFieldValue("district", e.label)}
                  />
                  {handleRegistration.touched.district && handleRegistration.errors.district ? (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {handleRegistration.errors.district}
                    </span>
                  ) : null}
                </Grid>
                <Grid item xs={12} lg={6}>
                  {/* <SoftBox display="flex" flexDirection="row"></SoftBox> */}
                  <SoftTypography fontWeight="medium" fontSize="15px">
                    Taluka
                  </SoftTypography>

                  <SoftInput
                    type="text"
                    placeholder="Enter taluka"
                    id="taluka"
                    name="taluka"
                    // value={payloadObj?.taluka}
                    // onChange={(e) => setPayloadObj({ ...payloadObj, taluka: e.target.value })}
                    value={handleRegistration.values.taluka}
                    onChange={handleRegistration.handleChange}
                  />
                  {/* {handleRegistration.touched.taluka && handleRegistration.errors.taluka ? (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {handleRegistration.errors.taluka}
                    </span>
                  ) : null} */}
                </Grid>
              </Grid>
              <Box
                sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", p: 1, mt: 2 }}
              >
                <Box
                  sx={{
                    p: !matchsm ? 1 : 0,
                    width: !matchsm ? "none" : "100%",
                    marginRight: !matchsm ? "0px" : "20px",
                  }}
                >
                  <SoftBox
                    pl={2}
                    sx={{
                      height: "45px",
                      backgroundColor: "#3B5092",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    p={{ lg: "13px 84px", sm: "13px 100px", xs: "13px 140px" }}
                    width={{ lg: "125px", sm: "100%", xs: "50%" }}
                    onClick={handleRegistration.handleSubmit}
                  >
                    <SoftTypography
                      display="flex"
                      justifyContent="center"
                      sx={{
                        color: "#fff",
                        fontSize: "15px",
                        fontWeight: "medium",
                        lineHeight: "19px",
                      }}
                    >
                      Submit
                    </SoftTypography>
                  </SoftBox>
                </Box>

                <Box
                  sx={{
                    p: !matchsm ? 1 : 0,
                    width: !matchsm ? "none" : "100%",
                    marginRight: !matchsm ? "0px" : "20px",
                    marginTop: !matchsm ? "0px" : "20px",
                  }}
                >
                  <SoftBox
                    pl={2}
                    sx={{
                      height: "45px",
                      backgroundColor: "#fff",
                      borderRadius: "5px",
                      border: "1px solid #3B5092",
                      cursor: "pointer",
                    }}
                    p={{ lg: "13px 84px", sm: "13px 100px", xs: "13px 140px" }}
                    width={{ lg: "125px", sm: "100%", xs: "50%" }}
                    onClick={() => {
                      setGenerateModal(false);
                      setPayloadObj({ name: "", mobile: "", state: "", district: "", taluka: "" });
                      handleRegistration.resetForm();
                    }}
                  >
                    <SoftTypography
                      display="flex"
                      justifyContent="center"
                      sx={{
                        color: "#3B5092",
                        fontSize: "15px",
                        fontWeight: "medium",
                        lineHeight: "19px",
                      }}
                    >
                      Cancel
                    </SoftTypography>
                  </SoftBox>
                </Box>
              </Box>
            </SoftBox>
          </SoftBox>
        </Modal.Body>
      </Modal>
      {/* Modal for assistant register */}
      {/* <MyComponent/> */}

      <Modal
        show={showqr}
        onHide={() => {
          setShowqr(false);
        }}
        size="md"
        centered
      // style={{marginTop:"52px",}}
      >
        <Modal.Header closeButton>QR Code</Modal.Header>
        <Modal.Body>
          <MyComponent Qrlink={Qrlink} test1={test1} setTest={setTest} showName={showName} />
        </Modal.Body>
      </Modal>
    </>
  );
}

const MyComponent = (props) => {
  // constructor(props) {
  //   super(props);
  //   this.componentRef = React.createRef();
  //   // eslint-disable-next-line react/prop-types
  //   console.log(this.props.Qrlink.qr_link)
  // }

  const componentRef = useRef();

  const date = new Date();

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  const handleDownloadImage = async () => {
    const element = componentRef.current;
    const canvas = await html2canvas(element);

    const data = canvas.toDataURL("image/jpg");
    const link = document.createElement("a");

    if (typeof link.download === "string") {
      link.href = data;
      // link.download = 'VolunteerQR_Date.jpg';
      link.download = `VolunteerQR_${day}-${month}-${year}.jpg`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      window.open(data);
    }
  };

  console.log(props.test1);

  //   useEffect(()=>{
  // urlToObject()
  //   },[])

  return (
    <>
      <div ref={componentRef} className="print">
        <p
          style={{
            paddingTop: "290px",
            fontSize: "20px",
            justifyContent: "center",
            display: "flex",
            fontWeight: "700",
            color: "#242b4d",
          }}
        >
          {" "}
          {props.showName}
        </p>
        <img
          // eslint-disable-next-line react/prop-types
          // src={this.props.Qrlink.qr_link}
          // src="https://samarth-storage-uat.s3.ap-south-1.amazonaws.com/Samarth/temp/qr/SMR-CP-689329.png"
          // src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcStsreGG0dPn882XOwLUxSUM7imF6u3XOJeLPX6dFHrS8hcx25VouDS8XAbx7Emm7JKT2g&usqp=CAU"
          // eslint-disable-next-line react/prop-types
          src={props.test1}
          style={{
            height: "210px",
            width: "215px",
            paddingTop: "7px",
            marginLeft: "117px",
            position: "relative",
          }}
        // className="qrimage"
        />
      </div>
      {/* <button onClick={() => exportComponentAsJPEG(this.componentRef)}>
          Export As JPEG
    </button>*/}
      <button
        onClick={() => {
          handleDownloadImage();
        }}
        style={{
          fontSize: "14px",
          width: "100%",
          backgroundColor: "#3b5092",
          color: "white",
          marginTop: "20px",
        }}
      >
        Download QR
      </button>

      {/* <input type="file" onChange={(e)=>props.setTest(URL.createObjectURL(e.target.files[0]))}/> */}
      {/* <button onClick={() => exportComponentAsPNG(componentRef)} style={{fontSize:"14px",width:"100%", backgroundColor:"#3b5092",color:"white", marginTop:"20px"}}>
          Download QR
        </button> */}
    </>
  );
};

// AdminEdit.propTypes = {
//   editadmin: PropTypes.bool.isRequired,
// }
